export default function callMeUpModal() {
  const MODAL = document.querySelector('.call-me-up-modal')
  const OPEN_MODAL_BUTTONS = document.querySelectorAll('.open-call-me-up-modal')

  if (!MODAL) {
    return
  }

  if (!OPEN_MODAL_BUTTONS.length) {
    return
  }

  for (let i = 0; i < OPEN_MODAL_BUTTONS.length; i++) {
    const BUTTON = OPEN_MODAL_BUTTONS[i]

    BUTTON.addEventListener('click', (e) => {
      e.preventDefault()
      window.openModal(MODAL)
    })
  }
}